import {IEnvironment} from '@environments/environment.model';

export const environment: IEnvironment = {
  production: false,
  serverApiUrl: 'http://localhost:8082',
  authServerApiUrl: 'http://localhost:8080'
};
